import type { SummitSessionFormat } from "~/lib/shared/types/summit";

const SESSION_FORMAT_LABELS: Record<SummitSessionFormat, string> = {
  presentation: "Presentation",
  workshop: "Workshop",
  panel: "Panel",
  "q&a": "Q&A",
  keynote: "Keynote",
};

export function formatSummitSessionFormat(
  format?: SummitSessionFormat | null,
): string {
  if (!format) {
    return "Session";
  }

  return SESSION_FORMAT_LABELS[format] ?? "Session";
}
